import { DirectionsRenderer } from "@react-google-maps/api";
import PropTypes from "prop-types";

export function MiDirectionsRenderer({ route = {}, options = {} }) {
  return <DirectionsRenderer directions={route} options={options} />;
}

MiDirectionsRenderer.propTypes = {
  route: PropTypes.object,
  options: PropTypes.object,
};
